import { render, staticRenderFns } from "./ToplistTable.vue?vue&type=template&id=365ec970"
import script from "./ToplistTable.vue?vue&type=script&lang=js"
export * from "./ToplistTable.vue?vue&type=script&lang=js"
import style0 from "./ToplistTable.vue?vue&type=style&index=0&id=365ec970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports